import React, { useEffect, useState } from "react";
import { Badge, Alert } from "react-bootstrap";
import { listDisputes } from "../services/partnerAuthService";

const getErr = (err, fallback) => err.response?.data?.error || fallback;
const TONE = { Open: "warning", InReview: "info", Resolved: "success", Rejected: "danger" };
const REASON_LABEL = {
  ServiceNotProvided: "Service not provided",
  WrongService: "Wrong service",
  PartnerIssue: "Partner issue",
  RefundIssue: "Refund issue",
  Other: "Other",
};

export default function Disputes() {
  const [disputes, setDisputes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    listDisputes()
      .then(({ data }) => setDisputes(data.data || []))
      .catch((err) => setError(getErr(err, "Failed to load disputes")))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Loading disputes…</p>;

  return (
    <div>
      <h4 className="mb-3">Disputes</h4>
      {error && <Alert variant="danger">{error}</Alert>}
      <p className="text-muted small">To raise a new dispute on a booking, go to Bookings and use "Raise Dispute" on the relevant booking.</p>

      {disputes.length === 0 ? (
        <div className="partner-card partner-empty">No disputes raised.</div>
      ) : (
        <div className="d-flex flex-column gap-3">
          {disputes.map((d) => (
            <div key={d._id} className="partner-card">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <h6 className="mb-0">{REASON_LABEL[d.reason] || d.reason}</h6>
                <Badge bg={TONE[d.status] || "secondary"}>{d.status}</Badge>
              </div>
              {d.description && <p className="mb-1">{d.description}</p>}
              {d.resolution && <p className="mb-1 text-muted small"><strong>Resolution:</strong> {d.resolution}</p>}
              <small className="text-muted">Raised by {d.raisedBy} · {new Date(d.createdAt).toLocaleDateString()}</small>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
